import { graphql } from "react-relay";

// components
import "@components/onboarding-nux/OnboardingNUXRenderer.gql";

export const webAppOnboardingFragments = {
  viewer: graphql`
    fragment WebAppOnboarding_viewer on Viewer {
      user {
        flowStates(first: 1000000) {
          edges {
            node {
              id
              flowKey
              previousState
              current {
                id
                state
                percentComplete
                errorMessage
              }
              pending {
                id
                state
                percentComplete
                errorMessage
              }
            }
          }
        }
        orgs(first: 1000000) {
          edges {
            node {
              id
              experiments
              ...OnboardingNUXRenderer_org
            }
          }
        }
      }
    }
  `,
};

export const webAppOnboardingQuery = graphql`
  query WebAppOnboardingQuery {
    viewer {
      ...WebAppOnboarding_viewer
    }
  }
`;
